import React from 'react'
import { LazyLoadComponent } from 'react-lazy-load-image-component'

import SimpleErrorPage from 'components/error/SimpleErrorPage'
import MainContainerQuery from 'components/api/queries/MainContainerQuery.gql'
import HeroContainer from './HeroContainer'
import HowItWorksCardsContainer from './HowItWorksCardsContainer'
import ValueProp from './ValueProp'
import WhoWeAre from './WhoWeAre'
import FeaturedProfiles from './FeaturedProfiles'
import Testimonials from './Testimonials'
import AsFeaturedIn from './AsFeaturedIn'
import CareGuide from './CareGuide'
import SafeCommunity from './SafeCommunity'
import { useQuery } from '@apollo/client'

const MainContainer = () => {
  const { loading, error, data } = useQuery(MainContainerQuery)

  if (error) {
    return <SimpleErrorPage error={error} />
  }

  if (loading || !data || !data.site || !data.site.assets) {
    return null
  }

  const {
    heroHeading,
    heroSubheading,
    findProviderButton,
    newListingPathText,
    lookingFor,
    testimonialContent,
    testimonialAuthor,
    hiwStep1,
    hiwStep2,
    hiwStep3,
    hiwStepCtaLink,
    helpingHeader,
    helping1,
    helping2,
    helping3,
    helping4,
    seoCallOutHeading,
    seoCallOutContent,
    listings,
    featuredProvidersHeader,
    featuredProvidersCta,
    featuredProvidersCtaLink,
    careguideImageUrl,
    careguideDescription,
    careguideHeader,
    statementHeader,
    homeNeighbourhoodImageUrl,
  } = data.site.assets

  return (
    <>
      <HeroContainer
        heroHeading={heroHeading}
        heroSubHeading={heroSubheading}
        findProviderButtonText={findProviderButton}
        heroLink={newListingPathText}
        seekerLookingFor={lookingFor}
      />
      <HowItWorksCardsContainer
        hiwStep1={hiwStep1}
        hiwStep2={hiwStep2}
        hiwStep3={hiwStep3}
        hiwStepCtaLink={hiwStepCtaLink}
      />
      <LazyLoadComponent>
        <ValueProp
          helpingHeader={helpingHeader}
          helping1={helping1}
          helping2={helping2}
          helping3={helping3}
          helping4={helping4}
        />
      </LazyLoadComponent>
      <LazyLoadComponent>
        <FeaturedProfiles
          listings={listings}
          featuredProvidersHeader={featuredProvidersHeader}
          featuredProvidersCta={featuredProvidersCta}
          featuredProvidersCtaLink={featuredProvidersCtaLink}
          imageURL={homeNeighbourhoodImageUrl}
        />
      </LazyLoadComponent>
      <LazyLoadComponent>
        <WhoWeAre heading={seoCallOutHeading} content={seoCallOutContent} />
      </LazyLoadComponent>
      <LazyLoadComponent>
        <Testimonials
          testimonialAuthor={testimonialAuthor}
          testimonialContent={testimonialContent}
        />
      </LazyLoadComponent>
      <LazyLoadComponent>
        <AsFeaturedIn />
      </LazyLoadComponent>
      <LazyLoadComponent>
        <CareGuide
          careguideImageUrl={careguideImageUrl}
          careguideDescription={careguideDescription}
          careguideHeader={careguideHeader}
        />
      </LazyLoadComponent>
      <LazyLoadComponent>
        <SafeCommunity statementHeader={statementHeader} />
      </LazyLoadComponent>
    </>
  )
}

export default MainContainer
